import { Button, Card, Stack, styled } from "@mui/material";

export const AppLoadingButton = styled(Button)<{ spinnerColor?: string }>(({ sx, spinnerColor }) => ({
    "& .MuiCircularProgress-root": { color: spinnerColor ?? `#3A73FF` },
    ...(sx as Record<string, string>),
}));

export const LoginButton = styled(Button)(({ theme }) => ({
    background: theme.palette.account.accent,
}));

export const accountInputBoxCSS = {
    "& div, input, label, fieldset, legend": {
        border: `none`,
    },
    "& input": {
        background: `#F5F4F2`,
        border: `1px solid #EFEFEF`,
        borderRadius: `4px`,
        boxShadow: `0 0 0 50px #F5F4F2 inset !important`,
        paddingRight: `25px`,
    },
    "& label": {
        color: `#666`,
    },
};

export const SignInCard = styled(Card)<{ size?: string; wide?: boolean; lastPage?: boolean }>(
    ({ theme, size, wide, lastPage }) => ({
        ...(size === `small` ? { border: `none` } : {}),
        display: `flex`,
        flexDirection: `column`,
        alignSelf: `center`,
        width: `100%`,
        borderRadius: 4,
        padding: size === `small` ? theme.spacing(4) : `${theme.spacing(4)} 90px`,
        ...(lastPage ? { paddingTop: 62, paddingBottom: 62 } : {}),
        gap: theme.spacing(2),
        margin: `auto`,
        [theme.breakpoints.up(`sm`)]: {
            maxWidth: wide ? `750px` : `600px`,
        },
    })
);

export const SignInContainer = styled(Stack)<{ size?: string }>(({ size }) => ({
    padding: size === `small` ? 0 : 20,
    ...(size === `small` ? { boxShadow: `none` } : {}),
    ...(size === `small` ? { border: `none` } : {}),
    ...(size === `small` ? { background: `none` } : {}),
    marginTop: `10vh`,
}));
